import { render } from "./InfoBanner.vue?vue&type=template&id=a5fffba2"
const script = {}

import "./InfoBanner.vue?vue&type=style&index=0&id=a5fffba2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__